import { HighlightGrid, Highlight, Link } from "@/components/design-system";

export function SeniorPoolHighlights() {
  return (
    <HighlightGrid>
      <Highlight
        heading="Diversified capital"
        body="The Senior Pool gives Liquidity Providers exposure to a variety of borrowers on the Goldfinch protocol. These borrowers span 25+ countries, and vary in use cases such as asset financing, SME loans and consumer loans. This is intended to serve investors in search of diversified yield generated through real world economic activity."
      />
      <Highlight
        heading="Protected by first-loss capital"
        body={<>All deals protected by 20-25% first-loss capital bar one legacy investment found <Link href="https://gov.goldfinch.finance/t/update-on-the-tugende-kenya-facility/1809">here</Link>.</>}
      />
      <Highlight
        heading="Secured"
        body="Overcollateralized with real-world off-chain assets."
      />
      <Highlight
        heading="Ongoing monitoring"
        body="Borrowers are required to provide quarterly reporting in secure datarooms."
      />
    </HighlightGrid>
  );
}
